import React from 'react';
import { Box, Card, CardContent, Grid, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const NotificationSettingsLinkCard: React.FC = () => {
  const navigate = useNavigate();
  return (
    <Grid item xs={12}>
      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom>Notifications</Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Email uses server SMTP settings. Configure SMS / Twilio and scheduled reports here.
          </Typography>
          <Button variant="contained" onClick={() => navigate('/settings/notifications')}>
            Open Notification Settings
          </Button>
        </CardContent>
      </Card>
    </Grid>
  );
};

export default NotificationSettingsLinkCard;
